export const USER_PROJECTS_PAGE_SIZE = 20;
export const USER_ASSETS_PAGES_SIZE = 20;
export const PAGE_SIZE_OPTIONS: string[] = ['10', '20', '30'];
export const REDIRECT_DELAY_MS = 2000;
